import { v4 as uuidv4 } from 'uuid';
import { ValueObject } from "./value-object";
export class UUID extends ValueObject<string> {
  constructor(value?: string) {

    if (!value) {
      super(uuidv4())
      return;
    };
    const isValidUUID = UUID.validate(value);
    if (!isValidUUID) throw new Error('Invalid UUID');
    super(value)
  }

  static validate(input: string): boolean {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(input);
  }
} 
